export default __webpack_public_path__ + "static/media/help_icon.d579ec48.svg";